module.exports = __webpack_public_path__ + "img/6.1.f139eb76.jpg";